export class AlertStatusCheckbox {
  constructor(
    public label: string,
    public value: string,
    public checked: boolean
  ) {}
}

export class Alert {
  constructor(
    public alertDatetime: string,
    public pointReference: string,
    public status: string,
    public rule: string
  ) {}
}

export class AlertRules {
  constructor(public id: string, public name: string) {}
}

export class ServiceOrder {
  constructor(
    public id: string,
    public reference: string,
    public serviceIdentifier: string,
    public creationDate: string,
    public status: string,
  ) {}
}

export class ServiceOrderInformation {
  constructor(
    public id: string,
    public creationDate: string,
    public user: string,
    public installation: string,
    public reference: string,
    public alertId: string,
    public status: string,
    public assignee: User | null,
  ) {}
}

export class GeneratedEvents {
  constructor(
    public alertRuleName: string,
    public generatedEvents: EventModel[]
  ) {}
}

export class EventModel {
  constructor(public eventName: string, public eventValue: any) {}
}

export class Alerts {
  constructor(
    public id: string | null,
    public installation: Installations | null,
    public firstAlertDatetime: string | null,
    public lastAlertDatetime: string | null,
    public alertCode: string,
    public alertDescription: string,
    public alertState: string,
    public occurrences: number | null,
    public eventsCount: number | null,
  ) {}
}

export class Installations {
  constructor(
    public id: string | null,
    public reference: string | null,
    public latitude: number | null,
    public longitude: number | null,
    public deviceMac: string | null,
  ) {}
}

export class User {
  constructor(
    public id: string,
    public username: string,
  ) {}
}

export class EquipmentAlerts {
  constructor(
    public reference: string | null,
    public route: string | null = null,
    public eventCode: EventCode,
    public device: string | null,
    public alertDatetime: string | null,
    public latitude: string | null,
    public longitude: string | null,
  ) {}
}
export class EventCode {
  constructor(
    public cod: string | null = null,
    public description: string | null
  ) {}
}

export class PaginationInfo {
  constructor(
    public count: number,
    public total: number,
    public hasNextPage: boolean,
    public hasPreviousPage: boolean,
    public startCursor: string | null,
    public endCursor: string | null
  ) {}
}

export class Gateway {
  constructor(public id: string, public reference: string) {}
}
